<template>
  <div class="redirect-page">
    <p>Redirecting...</p>
    <p><a :href="target" rel="noopener noreferrer" target="_blank">Click here if not redirected</a></p>
  </div>
</template>

<script>
import * as AT from "@/store/actionTypes";
export default {
  name: "ExternalRedirect",
  props: {
    target: {
      type: String,
      required: true
    }
  },
  mounted() {
    // Redirect the user immediately to the external URL
    try {
      if (this.target) {
        let last12 = this.target.slice(-12);
        this.$store
          .dispatch(AT.FIRE_PIXEL, { eventType: "event", event: "pdf-" + last12 })
          .then(() => console.log())
          .catch((error) => console.log(error))
          .finally(() => {
            window.location.replace(this.target);
          });
      }
    } catch (e) {
      // fail silently; user can click the link manually
      console.error("Redirect failed", e);
    }
  }
};
</script>

<style scoped>
.redirect-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  font-family: Arial, sans-serif;
  color: #333;
}
.redirect-page a {
  color: #1976d2;
  text-decoration: underline;
}
</style>
